import React from 'react'
import { render } from 'react-dom'
import { createDiv } from '../../../NonReact/DOM/DOMUtils'
import { VersionsConfigDTO } from '../../../NonReact/Types/Types'
import { getVersionsConfig } from '../../Common/API/GenericConfigAPI'
import { UserTour } from '../Main/UserTour'
import { TourEntry } from '../Types/Types'
import { JSONResponse } from '../../../NonReact/common/Types/Types'

export const enableUserTour = (entries: TourEntry[]): void => {
    const { error }: Console = console
    const containerDiv: HTMLDivElement = createDiv('touring')

    document.body.appendChild(containerDiv)

    // Lookup the version of the user tour from the server.
    getVersionsConfig()
        .then((response: JSONResponse<VersionsConfigDTO>): void => {
            if (response) {
                render(<UserTour version={response.userTour} entries={entries} />, containerDiv)
            }
        })
        .catch((e: Error): void => error(e))
}
